import type { CarrierLogoProps } from './types'
import LogoSvg from '../../assets/carrier-logos/ups-logo.svg?react'
import { chakra } from '../../chakra'
import { getLogoProps } from './use-logo-props'
import * as React from 'react'

const Logo = chakra(LogoSvg)

export const UPSLogo = React.forwardRef<SVGSVGElement, CarrierLogoProps>(
  function UPSLogo(props, ref) {
    const logoProps = getLogoProps(props)

    return <Logo {...logoProps} ref={ref} />
  },
)
